import { render, staticRenderFns } from "./subItem.vue?vue&type=template&id=6b4a8f3a"
import script from "./subItem.vue?vue&type=script&lang=js"
export * from "./subItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b4a8f3a')) {
      api.createRecord('6b4a8f3a', component.options)
    } else {
      api.reload('6b4a8f3a', component.options)
    }
    module.hot.accept("./subItem.vue?vue&type=template&id=6b4a8f3a", function () {
      api.rerender('6b4a8f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/navMenu/subItem.vue"
export default component.exports